import {useQuery} from 'react-query'
import {PageEditModalForm} from './PageEditModalForm'
import {isNotEmpty, QUERIES} from '../../../../../_dashboard/helpers'
import {useListView} from '../core/ListViewProvider'
import {getOneByIdbylang} from '../../../../services/common_requests'
import {initialPage, Page} from '../core/_models'

function unwrapPagePayload(payload: any): Page | undefined {
  if (!payload || typeof payload !== 'object') return undefined
  if (Array.isArray(payload.translations) || payload.slug != null || payload._id) {
    return payload as Page
  }
  if (payload.data) return unwrapPagePayload(payload.data)
  return undefined
}

const PageEditModalFormWrapper = () => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)
  const {
    isLoading,
    data: PagePayload,
    error,
  } = useQuery(
    `${QUERIES.PAGES_LIST}-Page-${itemIdForUpdate}`,
    () => {
      return getOneByIdbylang(`/pages/${itemIdForUpdate}?language=all`)
    },
    {
      cacheTime: 0,
      enabled: enabledQuery,
      onError: () => {
        setItemIdForUpdate(undefined)
      },
    }
  )

  const Page = unwrapPagePayload(PagePayload)

  if (!itemIdForUpdate) {
    return <PageEditModalForm isPageLoading={isLoading} Page={{...initialPage, _id: undefined}} />
  }

  if (!isLoading && !error && Page) {
    return <PageEditModalForm isPageLoading={false} Page={Page} />
  }

  return null
}

export {PageEditModalFormWrapper}
